import React from 'react';

// Session name inclusion notification
const FirstStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_name,
    conference_short_name,
    conference_organizer,
    // conference_date,
    conference_from_date,
    conference_to_date,
    conference_location,
    session_title,
    brief_overview,
    paper_title,
    relevant_field,
    specific_sdg_goal_numbers,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Dear ${client_name},` : ` Dear [Client Name],`}</p>

      <p>
        Greetings from{' '}
        <strong>
          {conference_organizer
            ? conference_organizer
            : `[IFERP/Conference Organizer]`}
          !
        </strong>
      </p>

      <p>
        <strong>
          Find your session suits your paper perfectly at{' '}
          {conference_short_name
            ? conference_short_name
            : '[Conference Short Name]'}{' '}
          accredited by CPD, scheduled for{' '}
          {conference_from_date
            ? `${conference_from_date}`
            : '[Conference Date]'}{' '}
          at{' '}
          <strong>
            {' '}
            {conference_location
              ? conference_location
              : '[Conference Location]'}
          </strong>
          .
        </strong>
      </p>

      <h6>
        <strong>Session Details:</strong>{' '}
        {session_title ? session_title : '[Session Title]'}
      </h6>
      <h6>
        <strong>Paper Presentation: </strong> "
        {session_title ? session_title : '[Session Title]'}" – Contributing
        innovative research in{' '}
        <strong>{relevant_field ? relevant_field : '[Relevant Field]'}</strong>{' '}
        and supporting SDG goals{' '}
        <strong>
          {specific_sdg_goal_numbers
            ? specific_sdg_goal_numbers
            : `[specific SDG goal numbers]`}
        </strong>
        .
      </h6>

      <h6>
        <strong>Why Attend?</strong>
      </h6>
      <ul>
        <li>
          <strong>Global Recognition:</strong> Showcase your work aligned with
          the UN’s SDGs.
        </li>
        <li>
          <strong>Publication Opportunity:</strong> Get published in
          Scopus-indexed journals.
        </li>
        <li>
          <strong>Professional Growth:</strong> Earn CPD certification, CPD
          points, and 1-year CPD membership.
        </li>
        <li>
          <strong>Exclusive Benefits:</strong> Scholarships, certifications, and
          international awards await!
        </li>
      </ul>
      <p>
        This is a fantastic opportunity to enhance your academic profile and
        connect with global experts. Feel free to reach out for any assistance.
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>

      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default FirstStepWhatsappTemplate;
